<template>
  <span>
    <HqDrawer
      :title="status == 'add'?'新增':(status == 'detail' ? '查看详情' :'编辑')"
      :visible.sync="drawerVisible"
      size="70%"
      ref="drawer"
      @on-cancel="cancel"
    >
      <div style="width: 90%;margin: 0 auto;padding: 12px 0 100px 0" class="pageform">
        <el-form ref="form" :model="form" :rules="addruleValidate">

          <el-row :gutter="24">
            <el-col :span="24">
              <p class="section_title">学员信息</p>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="orderNo">
                <v-text-field
                  v-model="form.orderNo"
                  label="学员订单号"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="studentName">
                <v-text-field
                  v-model="form.studentName"
                  label="学员姓名"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  readonly
                  @click.native="onOpenChoiceStudent"
                  
                  suffix-icon="el-icon-search"
                  :disabled="status != 'add'"
                ></v-text-field>
              </el-form-item>
            </el-col>

            <StudentOrder ref="studentOrderModalRef" @on-ok="onGoodsDrawerOk" :visible.sync="showStudentOrderModal" />

            <!-- <el-col :span="12">
              <el-form-item prop="sex">
                <dict-select code="SEX">
                  <v-select
                    v-model="form.sex"
                    slot-scope="props"
                    :items="props.dictData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="性别"
                    item-text="label"
                    item-value="label"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    :disabled="status == 'detail'"
                  ></v-select>
                </dict-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item prop="mobilePhone">
                <v-text-field
                  v-model="form.mobilePhone"
                  label="学员手机号"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item prop="idcard">
                <v-text-field
                  v-model="form.idcard"
                  label="学员身份证号"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="12">
              <el-form-item prop="educationName">
                <dict-select code="EDUCATION_TYPE">
                  <v-select
                    v-model="form.educationName"
                    slot-scope="props"
                    :items="props.dictData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="学历"
                    item-text="label"
                    item-value="label"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    disabled
                  ></v-select>
                </dict-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item prop="subscribeSchoolName">
                <v-text-field
                  v-model="form.subscribeSchoolName"
                  label="成交校区"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="goodsName" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.goodsName"
                  label="报读商品"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <p class="section_title">教学辅导内容</p>
            </el-col>


            <el-col :span="12">
              <el-form-item prop="tutoringMonth">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="form.tutoringMonth"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.tutoringMonth"
                      label="辅导日期"
                      hide-details="auto"
                      outlined
                      :dense="true"
                      :height="32"
                      :clearable="true"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="status == 'detail'"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.tutoringMonth" no-title locale="zh-cn">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">取消</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(form.tutoringMonth)">
                      确认
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </el-form-item>

            </el-col>

            <el-col :span="12" >
              <el-form-item prop="tutorName">
                <!-- <teacher-select>
                  <v-autocomplete
                    v-model="form.tutor"
                    slot-scope="props"
                    :items="props.teacherData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="辅导老师"
                    item-text="userName"
                    item-value="userId"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    @change="changeTeacher"
                    no-data-text="暂无数据"
                    :disabled="status == 'detail'"
                  ></v-autocomplete>
                </teacher-select> -->
                <v-text-field
                  v-model="form.tutorName"
                  label="辅导老师"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="status == 'detail'"
                ></v-text-field>

              </el-form-item>
            </el-col>

            <!-- <el-col :span="12" v-if="status == 'detail'">
              <el-form-item prop="tutorName">
                <teacher-select>
                  <v-autocomplete
                    v-model="form.tutorName"
                    slot-scope="props"
                    :items="props.teacherData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="辅导老师"
                    item-text="userName"
                    item-value="userName"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    @change="changeTeacher"
                    no-data-text="暂无数据"
                    :disabled="status == 'detail'"
                  ></v-autocomplete>
                </teacher-select>
                
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item prop="tutoringDuration" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.tutoringDuration"
                  label="一对一辅导分钟数"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="status == 'detail'"
                  @input="changeTutoringDuration"
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="guidanceWay">
                <v-autocomplete
                  v-model="form.guidanceWay"
                  :items="guidenceTypeList"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="辅导方式"
                  item-text="name"
                  item-value="name"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  clear-icon="$clear"
                  hide-details="auto"
                  @change="changeGuidenceType"
                  no-data-text="暂无数据"
                  :disabled="status == 'detail' || status == 'passEdit'"
                ></v-autocomplete>
              </el-form-item>
            </el-col>
            
            <el-col :span="24">
              <el-form-item prop="img">
                <div class="upload-box upload-box-fujian">
                  <el-upload
                    class="avatar-uploader"
                    v-if="imgList.length < 8 && status !== 'detail'"
                    :action="imgUploadDK.host"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess()"
                    :data="imgUploadDK"
                    :before-upload="beforeAvatarUpload()"
                    auto-upload
                    :http-request="uploadRequest()"
                    >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div style="position:relative;display: flex;" v-if="imgList.length>0">
                    <span v-for="(item,index) in imgList" style="position:relative; margin-right:10px;">
                      <el-image 
                        :key="index"
                        class="avatar"
                        style="object-fit:contain"
                        :src="item" 
                        :preview-src-list="[item]">
                      </el-image>
                      <div @click="removePic(index)" v-if="status !== 'detail'" style="cursor: pointer;font-size:20px;color:#fff;line-height:26px;text-align:center;position:absolute;border-radius:13px; width:26px;height:26px; right:-10px;top:-10px; background-color:red">x</div>

                    </span>
                  </div>

                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item prop="remark">
                <v-textarea
                  v-model="form.remark"
                  outlined
                  :height="100"
                  name="input-7-4"
                  label="定向一对一辅导内容"
                  value=""
                  maxlength="100"
                  :disabled="status == 'detail'"
                ></v-textarea>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="note">
                <v-textarea
                  v-model="form.note"
                  outlined
                  :height="80"
                  name="input-7-4"
                  label="备注"
                  value=""
                  :disabled="status == 'detail'"
                ></v-textarea>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button v-if="status != 'detail'" @click="save" type="primary" :loading="btnLoading">确认</el-button>
      </div>

    </HqDrawer>
  </span>
</template>
<script>
import ValidateType from "@/utils/validate";
import dictSelect from "@/components/dictSelect";
import teacherSelect from "./teacherSelect";
import StudentOrder from "./modelStudentOrder";
import { getResTeachList } from "api/public";

import { doJiamiSeePhone } from "api/customer";
import Strhide from "@/utils/strhide";
import Crypto from "@/utils/crypto";

import {
  addOneOnOneGuidance, 
  updateOrDeleteOneOnOneGuidance, 
  getPeiyouXieyiSignUrl, 
  getPreviewUrlForBestSign,
  // checkOneOnOneGuidanceMonth, 
  checkOneOnOneGuidance
} from "@/api/count";
import { formatTimes,formatTimesFileName, formatTimesHour } from "@/utils/timeDate";
import { getOrderListPage } from "api/order/change";

import axios from 'axios'
import md5 from 'md5';

import html2canvas from 'html2canvas';

export default {
  name: "oneOnOneModelAddEditDetail",
  components: {
    dictSelect,
    teacherSelect,
    StudentOrder
  },
  props: {
    method: {
      type: Function
    }
  },
  data() {
    return {
      guidenceTypeList:[
        {id: 1, name: '线上'},
        {id: 2, name: '线下'},
      ],
      imgList: [],
      status: 'add',// 'add'/'edit'/'detail'
      noJiamiPhone:'',// 11位学员手机号
      drawerVisible: false,
      showStudentOrderModal: false,

      form: {
        orderNo: '',
        studentName: '',
        sex: '',
        mobilePhone: '',
        idcard: '',
        education: '',//新加
        educationName: '',
        subscribeSchoolName: '',
        goodsName: '',
        goodsId: '',


        tutoringMonth: '',

        tutorName: '',
        tutor: '',

        remark: '',
        photoUrl: '',

        tutoringDuration: '', //辅导时长分钟
      },
      HistroyForm: {
        tutoringMonth:'',//辅导月份
        detailTutoringMonth:'',//详情辅导月份
      },
      CheckFormMsg: '',
      // isShowPeiyou: false,
      Formmoney: {},

      teacherList:[],//老师列表
      imgUploadDK: {
        //商品名字
        name: '',
        //路径
        key: "",
        OSSAccessKeyId: "",
        success_action_status:200,
        expire : "",
        host : "https://hq-tianyi.hqjy.com",
        policy : '',
        signature : ''
      },
      stopUpload: false,
      menu: false, // 就业时间控件开关
      btnLoading: false,// 是否提交成功
    };
  },
  watch: {
    form:{
      deep:true,
      handler(val){
        this.$nextTick(()=>{
          if(this.form.studentName){
            this.$refs['form'].validate()
          }
        })
      }
    }
  },
  computed: {
    addruleValidate() {
      // 选择学员后，判断学员订单号的就业申请是否审批（排除编辑状态时，最新就业单id == 编辑id）
      const validateStudentName = (rule, val, cb) =>  {
        // 非必填，如果为空或空字符串，直接通过
        if(val === null || val === undefined || val === '') {
          return cb(new Error("请选择学员"))
        }else{
          return cb();
        }
      };
      const validateGoodsName = (rule, val, cb) =>  {
        if (this.CheckFormMsg) {//
          return cb(new Error(`${this.CheckFormMsg}`));
        }
        return cb();
      };
      // 辅导日期
      const validateTutoringMonth = (rule, value, cb) => {
        if (value === null || value === undefined || value === '') {
          return cb(new Error('请选择辅导月份'));
        }
        // if (this.HistroyForm.tutoringMonth) {//
        //   if (this.status == 'add' && value == this.HistroyForm.tutoringMonth) {//新增
        //     return cb(new Error(`该订单已创建过${value}辅导月份`));
        //   }
        //   if(this.status != 'add' && value == this.HistroyForm.tutoringMonth && this.HistroyForm.tutoringMonth != this.HistroyForm.detailTutoringMonth ){
        //     return cb(new Error(`该订单已创建过${value}辅导月份`));
        //   }
        // }
        return cb()
      };
      return{
        studentName: [
          { message: '请选择学员', required: true },
          { validator: validateStudentName, trigger: 'change' }
        ],
        goodsName: [
          { validator: validateGoodsName, trigger: 'change' }
        ],
        tutoringMonth: [
          { message: '请选择辅导月份', required: true },
          { validator: validateTutoringMonth, trigger: 'change' }
        ],
        // tutor: [
        //   { message: '请选择辅导老师', trigger: 'blur', required: true }
        // ],
        tutorName: [
          { message: '请输入辅导老师', trigger: 'change', required: true }
        ],
        tutoringDuration: [
          { validator: ValidateType.minuteMust5, trigger: 'blur', required: true, }
        ],
        remark: [
          { message: '请输入定向一对一辅导内容', required: true, }
        ],
        guidanceWay: [
          { message: '请选择辅导方式', required: true }
        ],
        
      }
    },
  },
  mounted() {
    this.getAllList()
  },
  methods: {
    changeTutoringDuration(){
      // 查询课酬定向一对一辅导是否可以做单（选商品、维护辅导分钟数时）
      this.checkOneOnOneGuidance('inputTime')
    },
    changeGuidenceType(value){
      this.guidenceTypeList.map(item => {
        if(item.name === value) {
          this.form.guidanceWay = item.name
        }
      })
      this.$refs['form'].validate()
      
    },
    // changeTeacher(value) {// 就业老师
    //   // console.log('就业老师',value)
    //   this.teacherList.map(item => {
    //     if(item.userId === value) {
    //       this.form.tutor = item.userId
    //       this.form.tutorName = item.userName
    //     }
    //   })
    // },
    // 获取一开始的下拉框来源
    getAllList(){
      this.getTeacherList()
    },
    // 获取老师 -下拉框来源
    async getTeacherList() {
      const res = await getResTeachList()
      this.teacherList = res.result
    },

    onOpenChoiceStudent(row){
      this.showStudentOrderModal = true;
      this.$refs.studentOrderModalRef.init(row)
    },
    // 选择学员弹窗完毕
    async onGoodsDrawerOk(val) {
      console.log('[选中学员]', val);

      this.form.orderNo = val.orderNo
      this.form.studentName = val.userName? val.userName : val.studentName // 学员姓名
      this.form.mobilePhone = val.mobilePhone ? val.mobilePhone : val.phone
      this.form.idcard = val.idCard
      this.form.educationName = val.educationName // 学历名字
      this.form.education = val.education // 学历[新增 ]id
      this.form.subscribeSchoolName = val.subscribeSchoolName ? val.subscribeSchoolName : val.dealSchoolName //成交校区
      this.form.subscribeSchoolId = val.crmDealSchoolDeptId
      this.form.goodsName = val.goodsName ? val.goodsName : val.itemName
      this.form.goodsId = val.goodsId
      // 显示非加密手机号
      if(val.newPhone){
        this.noJiamiPhone = val.newPhone
      }else{
        let str = val.customerId.toString()
        let res = await doJiamiSeePhone(Crypto.encrypt(Strhide.getKeyHide(),Strhide.getIvHide(), str))
        this.noJiamiPhone = res.result
      }
      // 查询课酬定向一对一辅导是否可以做单（选商品、维护辅导分钟数时）
      this.checkOneOnOneGuidance()
      this.$refs['form'].validate()
    },
    // 获取学员订单查询课酬定向一对一辅导是否可以做单（选商品、维护辅导分钟数时）
    async checkOneOnOneGuidance(inputTime){
      if(!this.form.goodsName && !this.form.orderNo){
        return
      }
      if(inputTime && !this.form.tutoringDuration){
        return
      }
      if(inputTime && this.form.tutoringDuration){
        const re = /^[1-9][0-9]{0,4}$/
        const time = this.form.tutoringDuration
        if (!re.test(time)) {
          return
        }
      }
      const params = {
        orderNo: this.form.orderNo,
        goodsName: this.form.goodsName,
        ...this.form.id ? {id: this.form.id} : {},
        ...this.form.tutoringDuration ? {tutoringDuration: this.form.tutoringDuration} : {}
      }
      const { code, msg, result } = await checkOneOnOneGuidance(params)
      if (code == 0) {
        this.CheckFormMsg = ''
      } else {
        this.CheckFormMsg = msg// 返回的提示
      }
      this.$refs['form'].validate()// 为了选择订单后有正则提示
    },
    // 编辑初始化
    init(status,row) {
      this.HistroyForm = {
        tutoringMonth:'',//辅导月份
        detailTutoringMonth:'',//详情辅导月份
      }
      this.$refs.drawer.init()
      this.status = status// 'add'/'edit'/'detail'/
      if(status != 'add'){
        let rowData = JSON.parse(JSON.stringify(row))
        this.form = JSON.parse(JSON.stringify(row))
        console.log('this.form',this.form)
        this.noJiamiPhone = rowData.mobilePhone
        this.form.mobilePhone = this.formatJiamiPhone(this.form.mobilePhone)
        this.imgList = this.stringToArray(this.form.photoUrl)
        // this.form.tutor = this.form.tutor*1
        this.checkOneOnOneGuidance()
        // this.HistroyForm.detailTutoringMonth = this.form.tutoringMonth
      }else if(status === 'add'){
        this.form = {
          orderNo: '',
          studentName: '',
          sex: '',
          mobilePhone: '',
          idcard: '',
          education: '',//新加
          educationName: '',
          subscribeSchoolName: '',
          goodsName: '',
          goodsId: '',

          tutoringMonth: '',

          tutorName: '',
          tutor: '',

          remark: '',
          note: '',
          photoUrl: '',

          tutoringDuration: '', //辅导时长分钟
        }
        this.imgList.splice(0, this.imgList.length)
      }
      this.$nextTick(() => {
        this.$refs['form'].clearValidate();
      });
    },
    formatJiamiPhone(str) {
      const phone = String(str);
      if(phone.length==11){
        // 使用正则替换：捕获前3位和最后4位，中间的所有字符替换为4个星号
        return phone.replace(/^(.{3}).*(.{4})$/, '$1****$2');
      }else{
        return '';
      }
    },

    // 保存
    save(isXieyi) {
      this.$refs['form'].validate((valid) => {
        if(valid) {

          if( this.imgList.length==0 ){
            this.$message.error(`请上传jpg、jpeg、png的图片附件！`);
            return false;
          }

          if(this.form.remark.length > 100) {
            return this.$message.error(`定向一对一辅导内容在100字以内`)
          }
          if(this.form.note.length > 50) {
            return this.$message.error(`备注在100字以内`)
          }

          if(this.status ==='add'){
            // 新增的时候，存储不加密手机号
            this.form.mobilePhone = this.noJiamiPhone
            this.form.photoUrl = this.arrayToString(this.imgList)
            this.doAdd()
          }else if(this.status ==='edit'){
            delete this.form.mobilePhone// 编辑时不再传参手机号，由于编辑时为加密手机号，传参后会覆盖数据库原来的不加密手机号
            delete this.form.createId// 编辑时不传createId，因为新增时，传id后端把id转化为人名，重新编辑保存会报错
            this.form.photoUrl = this.arrayToString(this.imgList)
            console.log(this.form)
            this.doEdit()
          }
        }
      })
    },
    async doAdd(){
      this.form.createId = this.$store.state.user.loginUser.userId
      this.btnLoading = true
      const { code, msg, result } = await addOneOnOneGuidance(this.form)
      if (code == 0) {

        this.btnLoading = false
        this.$message.success('新增成功');
        this.method()// 刷新外层列表
        this.cancel()
        
      } else {
        this.btnLoading = false
        this.$message.warning(msg);
        this.cancel()
      }
    },
    async doEdit(sysControl){
      
      this.form.updateId = this.$store.state.user.loginUser.userId
      this.form.updateTime = formatTimes(new Date())
      this.form.isExist = 0
      this.btnLoading = true

        this.btnLoading = true
        const { code, msg } = await updateOrDeleteOneOnOneGuidance(this.form)
        if (code == 0) {
          if(sysControl){
            this.btnLoading = false
            this.method()// 刷新外层列表
            return
          }
          this.btnLoading = false
          this.$message.success('修改成功');
          this.method()// 刷新外层列表
          this.cancel()
        } else {
          this.btnLoading = false
          this.$message.warning(msg);
          this.cancel()
        }
      
    },

    // 取消
    cancel() {
      console.log('点击取消')
      this.btnLoading = false
      this.$refs['form'].clearValidate();
      this.CheckFormMsg = '', // 分钟累计提示语重置
      this.form = {
        orderNo: '',
        studentName: '',
        sex: '',
        mobilePhone: '',
        idcard: '',
        education: '',//新加
        educationName: '',
        subscribeSchoolName: '',
        goodsName: '',
        goodsId: '',

        tutorName: '',
        tutor: '',

        remark: '',
        note: '',
        photoUrl: '',
        
        tutoringDuration: '', //辅导时长分钟
      }
      this.imgList.splice(0, this.imgList.length)
      this.showStudentOrderModal = false;
      this.$refs.drawer.close()
    },
    // 将字符串转换为数组
    stringToArray(str) {
      if(str == '' || str == null){
        return []
      }
      let arrayData = str.split(';');
      return arrayData
    },
    // 将数组转换为字符串
    arrayToString(arr) {
      let outputString = arr.join(';');
      return outputString
    },
    //删除凭证图片
    removePic(index) {
      this.imgList.splice(index, 1)
    },
    /***
    * 成功上传图片的回调函数。
    * 属于一个高级函数，需要保存是多个上传图片控件的某一个上传的。
    */
    handleAvatarSuccess(type) {
      return ( _, file )=>{
        // this.form.isUploadSuccessDK = true; //已经上传成功
      }
    },
    /***
    * 图片上传前的检查；
    * 只允许这四种类型的图片上传： ["jpg", "jpeg", "bmp", "png"]
    */
    beforeAvatarUpload( type ){
      let _this = this
      return async ( file )=>{
        _this.stopUpload = true;
        let allowExt = ["jpg", "jpeg", "bmp", "png"];
        let isAllowUpload = allowExt.some( item=>{
            return file.type.indexOf( item ) > -1;
        })

        if (!isAllowUpload) {
          this.$message.error('上传凭证只允许 jpg、jpeg、bmp、png 格式!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
          isAllowUpload = false;
          _this.stopUpload = false;
          
          return isAllowUpload
        }
        console.log('图片上传前的检查_this.stopUpload',_this.stopUpload)

        let len = file.name.split('.')
        const time = formatTimesFileName(new Date()).replace(/-/g, '')
        console.log('isAllowUpload',this.imgUploadDK)

        const random = this.getRandomNum(10000, 99999)
        
        this.imgUploadDK.name = `${time}${random}.${len[len.length-1]}`

        return isAllowUpload
      }
    },
    uploadRequest(type) {
      return (op) => {
        console.log(123,op,this.stopUpload)
        this.myupload(
          op.file,
          type,
          res => {
            let temp = {
              name: res.attachment,
              url: res.aliyunAddress
            }
            // 成功后的回调，把结果返回，并且把上传列表的状态改变，打上成功的√
            op.onSuccess(temp)
          },
          err => {
            console.log(err)
          },
          res => {
          // 处理进度条的东西，把进度数据传进去实现进度条走动，传参res应该是这样的类型{percent: 48}
            op.onProgress(res)
          }
        )
      }
    },
    myupload(file, type, successCallback = new Function(), errCallBack = new Function(), progressCallback = new Function()) {
      let item = this.form;
      let imgList = this.imgList
      let fileName = file.name
      this.$fetch("ossSigniture", {code: 'tianyi'})
      .then(res => {
        let obj = res.data
        let config = {}
        config.host = obj['host']
        config.policyBase64 = obj['policy']
        config.accessid = obj['accessId']
        config.signature = obj['signature']
        config.expire = parseInt(obj['expire'])
        config.callbackbody = obj['callback']
        config.dir = obj['dir']
        // if(type === "scaleImgDK"){
          this.imgUploadDK.dir = obj.dir
        // }
        

        const random = this.getRandomNum(10000, 99999)
        const len = file.name.split('.')
        const time = formatTimesFileName(new Date()).replace(/-/g, '')
        const newName = `${time}${random}.${len[len.length-1]}`
        const renameFile = new File([file], newName, {type: file.type, uid: file.uid})
        // this.realFileList.push({uid: file.uid, name: newName})
        let form = new FormData(),
        key = config.dir + md5((this.$route.query.orderId || '') + '' + Date.now(), 8).substr(0, 10) + '_'
        form.append('name', newName)
        form.append('key', `${obj.dir}\${filename}`)
        form.append('policy', obj.policy)
        form.append('OSSAccessKeyId', obj.accessid)
        form.append('expire', obj.expire)
        form.append('host', obj.host)
        form.append('success_action_status', 200)
        form.append('signature', obj.signature)
        form.append('file', renameFile)
        if (config.host.indexOf('http:') > -1) {
          var protocol = window.location.protocol || 'http:'
          var subUrl = config.host.substring(5, config.host.length)
          config.host = protocol + subUrl
        }
        console.log('接口api--this.stopUpload',this.stopUpload)
        if(!this.stopUpload){
          return
        }
        axios({
          url: config.host,
          method: 'POST',
          data: form,
          processData: false,
          cache: false,
          contentType: false,
          onUploadProgress: function(progressEvent) {
            let host = "https://hq-tianyi.hqjy.com";
            // let photoUrl = `${host}/${this.imgUpload.dir}${this.imgUpload.name}`
            let photoUrl = `${host}/${config.dir}${newName}`
            // if(type === "scaleImgDK"){
              // item.photoUrl = process.env.VUE_APP_BASE_URL + "/mz_proxy?url="+encodeURI(photoUrl);
            // }
            let imgUrl = process.env.VUE_APP_BASE_URL + "/mz_proxy?url="+encodeURI(photoUrl);
            // item.imgList.push[imgUrl]
            if (!imgList.includes(imgUrl)) {
              imgList.push(imgUrl);
            }
            console.log('imgList',imgList,this.stopUpload)
            if (progressEvent.lengthComputable) {
              let percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
              progressCallback({ percent: percent })
            }
          }
        })
          .then(() => {
            let size = file.size > 1000000 ? parseFloat(file.size / 1000000).toFixed(2) + 'M' : parseFloat(file.size / 1000).toFixed(2) + 'KB'
            successCallback({
              attachment: fileName,
              aliyunAddress: key,
              size: size
            })
          })
          .catch(err => {
            errCallBack(err)
          })
      })
      .catch(err => {
        errCallBack(err)
        // console.log(err)
      })
    },
    getRandomNum(Min,Max) {
      let Range = Max - Min;
      let Rand = Math.random();
      return(Min + Math.round(Rand * Range));
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 26px !important;
}
::v-deep .el-form-item__error {
  padding-left: 10px !important;
}
.section_title{
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 10px;
}

::v-deep img {
  object-fit: contain;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 36px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #eee;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pageform {
  .upload-box {
    min-width: 100%;
    height: 100px;
    border: 1px solid #F0F0F3;
    display: flex;
    // justify-content: center;
    align-items: center;
    position: relative;
    margin-right: 15px;

    // &::before {
    //   position: absolute;
    //   content: "图片附件";
    //   left: 10px;
    //   top: -10px;
    //   font-size: 12px;
    //   color: #1976d2;
    // }

    .upload-btn {
      width: 100px;
      height: 100px;
      border: 1px solid #999;
      position: relative;
      cursor: pointer;

      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 36px;
        background: #999;
        left: 28px;
        top: 12px;
      }
      &::after {
        position: absolute;
        content: "";
        height: 4px;
        width: 36px;
        background: #999;
        left: 12px;
        top: 28px;
      }
    }
    .avatar{
      width: 100px;
      height: 100px;
    }

    .img-box {
      width: 94%;
      height: 96%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .upload-show{
    &::before {
      position: absolute;
      content: "";
      left: 10px;
      top: -10px;
      font-size: 12px;
      color: #1976d2;
    }
  }
  .upload-box-fujian{
    margin-left: 70px;
    border: 0;
    &::before {
      position: absolute;
      content: "图片附件";
      left: -60px;
      top: -10px;
      font-size: 12px;
      color: #1976d2;
    }
  }

}

::v-deep .el-dialog__header{
  text-align: left;
  .el-dialog__title{
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
}
</style>
